import React from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  createStyles,
  makeStyles,
  Theme,
  Divider,
  Typography,
} from '@material-ui/core';
import { Link } from 'react-router-dom';
import { SeasonViewQuery } from '../../../../../schema';
import { PropertiesTable, PropertiesTableRow } from '../../../../../ui/PropertiesTable';
import { formatDate } from '../../../../../helpers';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    content: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    imageContainer: {
      display: 'flex',
      justifyContent: 'center',
      marginBottom: theme.spacing(2),
    },
    seasonImage: {
      width: 200,
      height: 200,
      objectFit: 'cover',
      borderRadius: '50%',
    },
    currencySection: {
      width: '100%',
      marginTop: theme.spacing(2),
    },
    currencyRow: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(1),
    },
    currencyIcon: {
      width: theme.spacing(5),
      height: theme.spacing(5),
    },
    sectionTitle: {
      fontWeight: 500,
      marginBottom: theme.spacing(1),
    },
    colorBox: {
      display: 'inline-block',
      width: 24,
      height: 24,
      borderRadius: 4,
      marginRight: theme.spacing(1),
      verticalAlign: 'middle',
    },
    actions: {
      justifyContent: 'center',
    },
    divider: {
      width: '100%',
    },
    headerLabel: {
      fontWeight: 'bolder',
      marginBottom: '10px',
    },
  })
);

type Props = {
  data: SeasonViewQuery | undefined;
};

export const SeasonInfoCard = ({ data }: Props) => {
  const classes = useStyles();
  const season = data?.season;

  return (
    <Card>
      <CardHeader title="Информация о сезоне" />
      <CardContent className={classes.content}>
        <Typography component="div" variant="h5" align="center" className={classes.headerLabel}>
          Общая информация
        </Typography>
        {season?.generalInformation.image?.url && (
          <Box className={classes.imageContainer}>
            <img
              src={season.generalInformation.image.url}
              alt="Изображение сезона"
              className={classes.seasonImage}
            />
          </Box>
        )}

        <PropertiesTable>
          <PropertiesTableRow caption="Название" value={season?.generalInformation.title} />
          <PropertiesTableRow
            caption="Начало"
            value={
              season?.generalInformation.start ? formatDate(season.generalInformation.start) : '-'
            }
          />
          <PropertiesTableRow
            caption="Окончание"
            value={season?.generalInformation.end ? formatDate(season.generalInformation.end) : '-'}
          />
          <PropertiesTableRow caption="Описание" value={season?.generalInformation.description} />
          {season?.generalInformation.brandColor && (
            <PropertiesTableRow
              caption="Брендированный цвет"
              value={
                <>
                  <span
                    className={classes.colorBox}
                    style={{ backgroundColor: season.generalInformation.brandColor }}
                  />
                  {season.generalInformation.brandColor}
                </>
              }
            />
          )}
        </PropertiesTable>
        <Divider />

        <Box className={classes.currencySection}>
          <Typography component="div" variant="h5" align="center" className={classes.headerLabel}>
            Валюта
          </Typography>
          <Box className={classes.imageContainer}>
            {season?.currency.icon?.url && (
              <img
                alt={'Иконка валюты'}
                src={season.currency.icon.url}
                className={classes.seasonImage}
              />
            )}
          </Box>

          <PropertiesTable>
            <PropertiesTableRow
              caption="Название"
              value={season?.currency.name.nominativeSingular}
            />
          </PropertiesTable>
        </Box>
      </CardContent>
      <CardActions className={classes.actions}>
        <Button
          color="primary"
          variant="contained"
          component={Link}
          to={`/battle-pass/seasons/${season?.id}/edit`}
        >
          Редактировать
        </Button>
      </CardActions>
    </Card>
  );
};
